import * as Yup from 'yup';
import { ObjectSchema } from 'yup';
import { PlanDefinition } from '../../@types/Account';

export const getChoosePlanFormSchema = (
  planDefinitions: PlanDefinition[],
): ObjectSchema<any> => Yup.object().shape({
    pricingPlan: Yup.string().nullable().required('Please choose a plan'),
    maximumOpenPositions: Yup.number()
      .nullable()
      .when('pricingPlan', (pricingPlan, schema) => {
        const definition = planDefinitions?.find(
          (p) => p.pricingPlan === pricingPlan,
        );

        if (definition?.isCreditsBased) {
          return schema.optional();
        }

        return schema.min(1, 'Must be more then 1').required('Required field');
      }),
    maxUserSeats: Yup.number()
      .nullable()
      .when('pricingPlan', (pricingPlan, schema) => {
        const definition = planDefinitions?.find(
          (p) => p.pricingPlan === pricingPlan,
        );

        if (!definition?.isCreditsBased) {
          return schema.optional();
        }

        return definition?.userSeatsPlanLimit ?
          schema
              .min(1, 'Must be more then 1')
              .required('Required field')
              .max(
                definition?.userSeatsPlanLimit,
                'Cannot be higher then the plan limit',
              ) :
          schema;
      }),
    monthlyCredits: Yup.number()
      .nullable()
      .when('pricingPlan', (pricingPlan, schema) => {
        const definition = planDefinitions?.find(
          (p) => p.pricingPlan === pricingPlan,
        );

        if (!definition?.isCreditsBased) {
          return schema.optional();
        }

        return schema.min(1, 'Must be more then 1').required('Required field');
      }),
    extraMonthlyCredits: Yup.number()
      .nullable()
      .min(0, 'Must be more then 0')
      .optional(),
    customUnitPrice: Yup.number()
      .nullable()
      .min(1, 'Must be more then 1')
      .when('pricingPlan', (pricingPlan, schema) => {
        const definition = planDefinitions?.find(
          (p) => p.pricingPlan === pricingPlan,
        );

        return definition?.isCustomPlan ?
          schema.required('Required field') :
          schema.optional();
      }),
    endDate: Yup.string().nullable().optional(),
  });
